export default __webpack_public_path__ + "static/media/section2b-grid7img.0a0ea027.svg";